import React, {useState, useEffect} from 'react';
import { Container } from 'reactstrap';
import Buttons from '../buttons';
import { Enums, Utilities } from "@utils";
import FollowupSubProjectPresenter from "../../../../presenters/screens/followup-subproject.presenter";
import { IFollowupSubproject } from "@interfaces/screens/followup-subproject.interface";
import { SingleCollapse, AEAPopOver } from "@/components/";
import ByActivity from './by-activity/by-activity';
import ByAge from './by-age';
import ByLocation from './by-location';
import ByRurality from './by-rurality';

export interface IBeneficiariesProps{    
    projectData: any;
    screen: string;
    activeTab: number;
    setBeneficiariesActData: Function;
}

const FollowUpBeneficiaries: React.FC<IBeneficiariesProps> = ({projectData, screen, activeTab, setBeneficiariesActData} :IBeneficiariesProps) =>  {
    const [auxScreen, setAuxScreen] = useState(screen);
    const [dimensionData, setDimensionData] = useState(null);
    const [showData, setShowData] = useState<boolean>(false);
    const [dataColumns, setDataColumns] = useState(null);
    const [tableAlert, setTableAlerts] = useState<any>(null);
    const [refresh, setRefresh] = useState<any>(null);
    const [benActData, setBenActData] = useState(null);
    const [benResData, setBenResData] = useState(null);
    const [benOverData, setBenOverData] = useState<any>(null);
    const [initialValidate, setInitialValidate] = useState(true);
    const [finishTour, setFinishTour] = useState(false);

    const [missedBeneficiariesActData, setMissedBeneficiariesActData] = useState<any>([]);

    const view: IFollowupSubproject = {
        state: {
            dataColumns,
            projectData,
            refresh,
            benActData,
            benResData,
            benOverData,
            dimensionData,
            setDimensionData,
            setDataColumns,
            setBenActData,
            setBenResData,
            setBenOverData,
            setTableAlerts,
            setRefresh,
            missedBeneficiariesActData,
            setMissedBeneficiariesActData
        },
    };

	const presenter = new FollowupSubProjectPresenter(view);

    useEffect(() => {
        let isSubscribed = true;
        console.log("dimension enum "+Enums.FollowupDimensions.beneficiaries)
        if(presenter.subProjectDimensions?.length) presenter.getDimensionData(Enums.FollowupDimensions.beneficiaries)
        return () => {(isSubscribed = false)}
    }, [presenter.subProjectDimensions]);

    useEffect(() => {
        let isSubscribed = true;
        presenter.initBeneficiaries()
        return () => {(isSubscribed = false)}
    }, []);

    useEffect(() => {
        if(!!missedBeneficiariesActData.length) {
            setBeneficiariesActData(missedBeneficiariesActData)
        }
    }, [missedBeneficiariesActData]);

    useEffect(() => {
        let isSubscribed = true;
        if(activeTab === 1){
            if(benOverData && benResData && presenter.beneficiariesData && dimensionData && presenter.resultsFramework && benActData) presenter.unSetLoading()
            else presenter.keepLoading()
        }
        return () => {(isSubscribed = false)}
    }, [benOverData, benResData, presenter.beneficiariesData, dimensionData, presenter.resultsFramework, benActData, activeTab]);

    useEffect(() => {
        let isSubscribed = true;
        if(!!presenter.stepData && presenter.beneficiariesData){
            let auxAct = presenter.getByActData(presenter.stepData, projectData?.year, presenter.beneficiariesData);
            setBenActData(auxAct)
        }
        return () => {(isSubscribed = false)}
    }, [presenter.stepData, presenter.beneficiariesData]);

	useEffect(() => {
        let isSubscribed = true;
        if(presenter.resultsFramework && presenter.beneficiariesData) {
            let auxData = presenter.getBeneficiariesResultsData(presenter.resultsFramework, presenter.beneficiariesData, Number(projectData?.year), projectData)
		    setBenResData(auxData)
        }
        return () => {(isSubscribed = false)}
    }, [presenter.resultsFramework, presenter.beneficiariesData]);

    useEffect(() => {
        let isSubscribed = true;
        if(presenter.resultsFramework && presenter.beneficiariesData && benResData) {
            let auxData = presenter.getBeneficiariesOverlapsData(presenter.resultsFramework, benResData, benOverData, projectData?.year)
			setBenOverData(auxData)
        }
        return () => {(isSubscribed = false)}
    }, [presenter.resultsFramework, presenter.beneficiariesData, refresh, benResData?.length]); 

    useEffect(() => {
        let isSubscribed = true;
        if(dimensionData?.CodigoDimension && benOverData && benActData?.data){ 
            if(dimensionData?.CodigoDimension === Enums.FollowupState.followup && benOverData && benActData?.data?.length){ 
                let showData = presenter.checkBenPlanByRes(benOverData, benActData)
                setShowData(showData)
            }else setShowData(true)
        }
        if(dimensionData?.CodigoDimension === Enums.FollowupState.planning && benActData?.data){
            let auxValue = !presenter.checkInfoBeneficiaries(benActData?.data)
            setInitialValidate(auxValue)
        }
        return () => {(isSubscribed = false)}
    }, [benOverData, benActData, dimensionData?.CodigoDimension]);

    useEffect(() => {
        let isSubscribed = true;
        const canEdit = (screen === Enums.FollowupState.edit)
        if(dimensionData && presenter.subProjectDimensions && canEdit) {
            let isAllClosed: boolean = presenter.checkCloseMonths(dimensionData)
            let currentUser = presenter.getCurrentUser()
            let otherEdit = (!!dimensionData?.EnEdicion && currentUser.currentUser.userPrincipalName !== dimensionData?.PProaModifiedBy?.Name?.replace("i:0#.f|membership|", "")) || !dimensionData?.EnEdicion
            setAuxScreen((isAllClosed || otherEdit) ? Enums.FollowupState.view : screen)
        }
        return () => {(isSubscribed = false)}
    }, [presenter.subProjectDimensions, dimensionData, screen]);

    let visible = presenter.loadingFinished()
    let dimensionTour = (!presenter.tourBenSeen && dimensionData && showData) ? presenter.getTourDimension(Enums.FollowupDimensions.beneficiaries, dimensionData) : null

    useEffect(() => {
        if(!presenter.tourBenSeen && presenter.stepTourBen === 1 && visible && activeTab === 1 && showData){
            Utilities.notifyTour(presenter.followupLabels.get("BeneficiariesTourStep1"),
                presenter.followupLabels.get("tourWelcome"),
                `${presenter.followupLabels.get("tourBtnNext")} (${presenter.stepTourBen}/14)`,
                presenter.followupLabels.get("tourBtnSkip")
            )
            .then((res) => {
                if(res)presenter.changeStepTour(presenter.stepTourBen + 1, Enums.FollowupDimensions.beneficiaries);
                else setFinishTour(true)
            })
        }
    }, [presenter.tourBenSeen, presenter.stepTourBen, visible, activeTab, showData]);

    useEffect(() => {
        if(finishTour){
            presenter.toggleTour(Enums.FollowupDimensions.beneficiaries, true)
            setFinishTour(false)
        }
    }, [finishTour]);

    return (
        <Container fluid={true}>
            {
                (presenter.beneficiariesData && true && dimensionData) ?
                    <>
                        <Buttons 
                            initialValidate={initialValidate && dimensionData?.CodigoDimension === Enums.FollowupState.planning && presenter.tourBenSeen}
                            save={presenter.saveData} 
                            check={presenter.checkData} 
                            currentYear={Number(projectData?.year)}
                            dimensionData={dimensionTour || dimensionData} 
                            followupLabels={presenter.followupLabels}
                            formMasters={presenter.formMasters}
                            step={2} 
                            screen={screen}
                            toggleEditing={presenter.toggleEditing} 
                            currentUser={presenter.getCurrentUser()} 
                            startTour={() => presenter.toggleTour(Enums.FollowupDimensions.beneficiaries, false)}
                            stepTour={presenter.stepTourBen}
                            typed={Enums.FollowupDimensions.beneficiaries}
                          
                        />
                        <SingleCollapse keepOpen={!!tableAlert} title={presenter.followupLabels.get("beneficiariesByActivity")} isOpen={presenter.stepTourBen === 3 ? false : true} idTitle={'BeneficiariesTourStep2'} >
                            <ByActivity 
                                initialValidate={initialValidate && dimensionData?.CodigoDimension === Enums.FollowupState.planning && presenter.tourBenSeen}
                                tableAlert={presenter.tourBenSeen ? tableAlert : null} 
                                actData={benActData} 
                                overData={benOverData} 
                                resData={benResData} 
                                refresh={refresh} 
                                saveTable={presenter.saveTable} 
                                dataColumns={dataColumns} 
                                status={dimensionData} 
                                currentYear={projectData?.year} 
                                screen={!presenter.tourBenSeen ? Enums.FollowupState.edit : auxScreen} 
                                projectData={projectData} 
                            />
                        </SingleCollapse>
                        { (dimensionData?.CodigoDimension === Enums.FollowupState.followup || dimensionTour) ? 
                            <>
                                <SingleCollapse keepOpen={!!tableAlert} title={presenter.followupLabels.get("beneficiariesByAge")} isOpen={(tableAlert === "All" && presenter.tourBenSeen) ? true : false}>
                                    <ByAge tableAlert={presenter.tourBenSeen ? tableAlert : null} saveTable={presenter.saveTable} dataColumns={dataColumns} status={dimensionData} currentYear={projectData?.year} screen={!presenter.tourBenSeen ? Enums.FollowupState.edit : auxScreen} />
                                </SingleCollapse>
                                <SingleCollapse keepOpen={!!tableAlert} idTitle={'BeneficiariesTourStep3'} title={presenter.followupLabels.get("beneficiariesByLocation")} isOpen={((tableAlert === "All"  && presenter.tourBenSeen) || presenter.stepTourBen === 3) ? true : false}>
                                    <ByLocation tableAlert={presenter.tourBenSeen ? tableAlert : null} saveTable={presenter.saveTable} dataColumns={dataColumns} status={dimensionTour || dimensionData} currentYear={projectData?.year} screen={!presenter.tourBenSeen ? Enums.FollowupState.edit : auxScreen} />
                                </SingleCollapse>
                                <SingleCollapse keepOpen={!!tableAlert} title={presenter.followupLabels.get("beneficiariesByRurality")} isOpen={(tableAlert === "All" && presenter.tourBenSeen) ? true : false}>
                                    <ByRurality tableAlert={presenter.tourBenSeen ? tableAlert : null} saveTable={presenter.saveTable} dataColumns={dataColumns} status={dimensionData} currentYear={projectData?.year} screen={!presenter.tourBenSeen ? Enums.FollowupState.edit : auxScreen} />
                                </SingleCollapse>
                            </>
                        :<></>
                        } 
                        {(visible && !presenter.tourBenSeen) &&
                            <AEAPopOver
                                popOverScroll={presenter.getScrollTour(presenter.stepTourBen, Enums.FollowupDimensions.beneficiaries)}
                                stepPosition={presenter.getPositionTour(presenter.stepTourBen, Enums.FollowupDimensions.beneficiaries)} 
                                visible={visible && !presenter.tourBenSeen} 
                                step={presenter.stepTourBen} 
                                totalStep={14}
                                changeStepTour={(step: number) => presenter.changeStepTour(step, Enums.FollowupDimensions.beneficiaries)}
                                finishTour={() => presenter.toggleTour(Enums.FollowupDimensions.beneficiaries, true)} 
                                labelDimension={'BeneficiariesTourStep'} 
                                followupLabels={presenter.followupLabels}
                            /> 
                        } 
                    </>
                : <div style={{width:"100%", textAlign:"center", color:"red", padding:"1rem"}}>{presenter.followupLabels.get("errorInDimensionState")}</div>
            }
        </Container>
    );       
}

export default FollowUpBeneficiaries;